import { render, staticRenderFns } from "./task-header.vue?vue&type=template&id=2c20f355"
import script from "./task-header.ts?vue&type=script&lang=ts&external"
export * from "./task-header.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports